import React from 'react';

// Aimy / Aiden brand colours, kept as a baseline so mentions of an AI that is
// no longer a live participant (e.g. Aiden after Gemini was unconfigured)
// keep their identity — mirroring MessageBubble's historical-sender handling.
export const AI_BRAND_COLORS_BY_NAME = {
  aimy: '#d96f43',
  aiden: '#127c6d',
};

function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Render `@Name` mentions of the given participants — humans and AIs alike —
 * as coloured spans, each in that participant's colour, leaving everything
 * else as plain text. Used by both the message bubbles and the composer's
 * highlight layer so a directed message reads identically while typing and
 * after sending. Word-boundary matching keeps look-alikes ("@Aimyish")
 * plain. Returns the original string untouched when nothing matches.
 */
export function renderMentions(text, participants = [], keyPrefix = 'm') {
  if (!text || typeof text !== 'string') return text;
  const colorByName = new Map(Object.entries(AI_BRAND_COLORS_BY_NAME));
  for (const p of participants) {
    if (!p?.name) continue;
    const key = String(p.name).toLowerCase();
    const color = p.color || colorByName.get(key) || null;
    if (color) colorByName.set(key, color);
  }
  // Longest names first so "@Jane Doe" wins over a hypothetical "@Jane".
  const names = [...colorByName.keys()].filter(Boolean).sort((a, b) => b.length - a.length);
  if (names.length === 0) return text;
  const pattern = new RegExp(`(@(?:${names.map(escapeRegex).join('|')}))(?![a-zA-Z0-9_])`, 'gi');
  const parts = text.split(pattern);
  if (parts.length === 1) return text;
  return parts.map((part, i) => {
    const color = part.startsWith('@') ? colorByName.get(part.slice(1).toLowerCase()) : null;
    if (!color) return part;
    return (
      <span key={`${keyPrefix}-${i}`} className="mention-token" style={{ color }}>
        {part}
      </span>
    );
  });
}
